export const header = {
    account: 'Account Details',
    logout: 'Log Out',
}

export const detail = {
    carbonProject: 'Carbon Project',
    projectDetail: 'Project Detail',
    title: 'RIAU ECOSYSTEM RESTORATION CARBON PROJECT',
    value: 'Data Origin:',
    maptitle: 'Project Summary',
    projectid: 'Project ID:',
    pjname: 'Project Name:',
    country: 'Country:',
    pjtype: 'Project Type:',
    projectstatus: 'Project ID in Originating Registry:',
    pjstate: 'Province/State:',
    est: 'Project Developer/Proponent:',
    pj3rd: 'Project 3rd-Party Verifier:',
    csards: 'Credit Standards:',
    cmlogy: 'Credit Methodology:',
    pjststus: 'Project Status:',
    cpiod: 'Crediting Period:',
    asits: 'Annual Credits (estimated):',
    nfdt: 'NFDT™ Address:',
    text_title: 'Description',
    text_banner: 'The Riau Ecosystem Restoration Carbon Project seeks to protect and restore 130,090 ha of peatland ecosystem located in the Republic of Indonesia while at the same time preserving biodiversity and enhancing local livelihoods. The Project will avoid 78,425 ha of forest clearing and conversion to an industrial forestry plantation. The Project is on the island of Sumatra and in the Province of Riau. Specifically, it is located on the Kampar Peninsula, which is a rain-fed peatland forest made up of four former logging concessions. Through the REDD+ process of avoided planned deforestation and wetlands conservation and restoration, the Project will be preserving the remaining peat swamp forests by preventing their conversion to forestry plantations.',
    issuancelist: 'Credit Issuance',
    projectlist: 'Project Documents',
    vin: 'Vintage',
    quantity: 'Quantity',
    issdate: 'Issuance Date',
    doname: 'Document Name',
    dotype: 'Document Type',
    update: 'Update Date',
    view: 'View'
}

export const login = {
    title: 'Carbonland National Carbon Registry',
    tips: 'A Digital Registry Powered by the Blockchain NFDT Technology',
    login: 'Log In',
    username: 'Username',
    Password: 'Password',
    Forgot_Your_Password: 'Forgot Your Password?',
    FA: '2FA',
    Forgot_Your_FA_Code: 'Forgot Your 2FA Code?',
    LogIn: 'Log In',
    SignUp: 'Sign up'
}